import { default as HrmEmployeesConfig } from '../admin/hrm-employees/HrmEmployeesConfig';
import ApplicationsConfig from './applications/ApplicationConfig';
import AppointmentsConfig from './appointments/AppointmentsConfig';
import BlankConfig from './blank/BlankConfig';
import CalendarAppConfig from './calendar/CalendarAppConfig';
import ChatAppConfig from './chat/ChatAppConfig';
import ClaimsAppConfig from './claims/ClaimsAppConfig';
import CultureAppConfig from './culture/CultureAppConfig';
import DocumentsConfig from './documents/DocumentsConfig';
import HelpDeskAppConfig from './help-desk/HelpDeskAppConfig';
import ServiceDeskAppConfig from './helpservice/ServiceDeskAppConfig';
import IncomingDocumentsConfig from './incoming-documents/IncomingDocumentsConfig';
import InternalDocumentsConfig from './internal-documents/InternalDocumentsConfig';
import { default as LocalNormativeActsConfig } from './local-normative-acts/LocalNormativeActsConfig';
import MapAppConfig from './map/MapConfig';
import MemoryAppConfig from './memory/MemoryAppConfig';
import MyCalendarConfig from './my-calendar/MyCalendarConfig';
import DeskAppConfig from './my-drive/MyDriveAppConfig';
import NewsAppConfig from './news/NewsAppConfig';
import OrgStructureConfig from './org-structure/OrgStructureConfig';
import PresentationConfig from './presentation/PresentationConfig';
import PrintDocumentsConfig from './print-documents/PrintDocumentsConfig';
import ProfileAppConfig from './profile/ProfileAppConfig';
import ProjectsAppConfig from './projects/ProjectsConfig';
import SkudConfig from './skud/SkudConfig';
import BlocksDailyReportConfig from './skud/blocks-daily-report/BlocksDailyReportConfig';
import DepartmentsReportConfig from './skud/departments-report/DepartmentsReportsConfig';
import SkudDetailConfig from './skud/skud-detail/SkudDetailConfig';
import StaffAppConfig from './staff/StaffAppConfig';
import SupportConfig from './support/SupportConfig';
import TemplatesManagementConfig from './templates-management/TemplatesManagementConfig';
import VideoConferencesConfig from './video-conferences/VideoConferencesConfig';

const appsConfigs = [
  ProfileAppConfig,
  ChatAppConfig,
  OrgStructureConfig,
  HrmEmployeesConfig,
  ProjectsAppConfig,
  SkudConfig,
  SkudDetailConfig,
  BlankConfig,
  NewsAppConfig,
  MapAppConfig,
  HelpDeskAppConfig,
  CalendarAppConfig,
  SupportConfig,
  PresentationConfig,
  ClaimsAppConfig,
  InternalDocumentsConfig,
  IncomingDocumentsConfig,
  AppointmentsConfig,
  VideoConferencesConfig,
  CultureAppConfig,
  MemoryAppConfig,
  TemplatesManagementConfig,
  ApplicationsConfig,
  StaffAppConfig,
  PrintDocumentsConfig,
  DeskAppConfig,
  ServiceDeskAppConfig,
  DepartmentsReportConfig,
  BlocksDailyReportConfig,
  LocalNormativeActsConfig,
  MyCalendarConfig,
  DocumentsConfig,
];

export default appsConfigs;
